import { Route } from 'react-router-dom'
import useDocumentTitle from "hooks/misc/useDocumentTitle/useDocumentTitle"

const Page = ({ title, ...rest }) => {
  useDocumentTitle({ title })
  return (<Route { ...rest } />)
}

export default Page
